import React, { useState } from "react";
import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";
import FormInputTextComponent from "../form-input-text/form-input-text.component";

const FormInputColorPickerComponent = ({
  type,
  label,
  id,
  name,
  value,
  placeholder,
  error,
  onChange,
  onKeyDown,
  onFocus,
  isRequired = false,
  isVertical = false,
  isDisabled = false,
  inputStyles,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [color, setColor] = useColor("hex", value);

  console.log({color,value})

  const handleColorIcon = () => {
    console.log("clicked");
    setShowColorPicker(!showColorPicker);
  };

  const handleChangeColor = (color) => {
    console.log({ color });
    setColor(color);
    if (onChange) onChange(color.hex);
    // setShowColorPicker(!showColorPicker);
  };

  return (
    <>
      <FormInputTextComponent
        label={label}
        isVertical={isVertical}
        id={id}
        name={name}
        inputIcon={"feather"}
        inputIconStyles={{ background: color.hex }}
        handleInputIconClick={handleColorIcon}
        value={value}
        placeholder={placeholder}
        error={error}
        type={type}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        isRequired={isRequired}
        isDisabled={isDisabled}
        inputStyles={inputStyles}
      />
      {showColorPicker && (
        <div style={{ position: "absolute", width: 300, height: 250 }}>
          <ColorPicker
            width={456}
            height={228}
            color={color}
            onChange={handleChangeColor}
            // onChangeComplete={handleColorIcon}
            hideHSV
            dark
          />
        </div>
      )}
    </>
  );
};

export default FormInputColorPickerComponent;
